
export const data = [
    {
        id: 1,
        carID: '#HT001',
        carbrandAndModel: {
            details: [
                {
                    brand: 'Mercedes Benz',
                    model: 'S400',
                }
            ]
        },

        seatCapacity: {
            details: [
                {
                    totalSeat: 4,
                    babySeat: 'Yes'
                }
            ]
        },
        servicePrice: {
            details: [
                {
                    price: '$180.00',
                    fromLocation: 'Singapore Disposal',
                    toLocation: 'Malaysia Disposal',
                    fromDisposal: '$180.00',
                    toDisposal: '$215.00'
                }
            ]
        },
        extraPrice: {
            details: [
                {
                    extraStopSurcharge: '$ 15.00',
                    midnightSurcharge: '$ 15.00',
                    waitingTime: '$15.00'
                }
            ]
        },
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id: 2,
        carID: '#HT002',
        carbrandAndModel: {
            details: [
                {
                    brand: 'Mercedes Benz',
                    model: 'S400',
                }
            ]
        },
        model: 'S400',

        seatCapacity: {
            details: [
                {
                    totalSeat: 4,
                    babySeat: 'Yes'
                }
            ]
        },
        servicePrice: {
            details: [
                {
                    price: '$180.00',
                    fromLocation: 'Singapore Disposal',
                    toLocation: 'Malaysia Disposal',
                    fromDisposal: '$180.00',
                    toDisposal: '$215.00'
                }
            ]
        },
        extraPrice: {
            details: [
                {
                    extraStopSurcharge: '$ 15.00',
                    midnightSurcharge: '$ 15.00',
                    waitingTime: '$15.00'
                }
            ]
        },
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id: 3,
        carID: '#HT003',
        carbrandAndModel: {
            details: [
                {
                    brand: 'Mercedes Benz',
                    model: 'S400',
                }
            ]
        },
        model: 'S400',

        seatCapacity: {
            details: [
                {
                    totalSeat: 4,
                    babySeat: 'Yes'
                }
            ]
        },
        servicePrice: {
            details: [
                {
                    price: '$180.00',
                    fromLocation: 'Singapore Disposal',
                    toLocation: 'Malaysia Disposal',
                    fromDisposal: '$180.00',
                    toDisposal: '$215.00'
                }
            ]
        },
        extraPrice: {
            details: [
                {
                    extraStopSurcharge: '$ 15.00',
                    midnightSurcharge: '$ 15.00',
                    waitingTime: '$15.00'
                }
            ]
        },
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id: 4,
        carID: '#HT004',
        carbrandAndModel: {
            details: [
                {
                    brand: 'Mercedes Benz',
                    model: 'S400',
                }
            ]
        },
        model: 'S400',

        seatCapacity: {
            details: [
                {
                    totalSeat: 4,
                    babySeat: 'Yes'
                }
            ]
        },
        servicePrice: {
            details: [
                {
                    price: '$180.00',
                    fromLocation: 'Singapore Disposal',
                    toLocation: 'Malaysia Disposal',
                    fromDisposal: '$180.00',
                    toDisposal: '$215.00'
                }
            ]
        },
        extraPrice: {
            details: [
                {
                    extraStopSurcharge: '$ 15.00',
                    midnightSurcharge: '$ 15.00',
                    waitingTime: '$15.00'
                }
            ]
        },
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id: 5,
        carID: '#HT005',
        carbrandAndModel: {
            details: [
                {
                    brand: 'Mercedes Benz',
                    model: 'S400',
                }
            ]
        },
        model: 'S400',

        seatCapacity: {
            details: [
                {
                    totalSeat: 4,
                    babySeat: 'Yes'
                }
            ]
        },
        servicePrice: {
            details: [
                {
                    price: '$180.00',
                    fromLocation: 'Singapore Disposal',
                    toLocation: 'Malaysia Disposal',
                    fromDisposal: '$180.00',
                    toDisposal: '$215.00'
                }
            ]
        },
        extraPrice: {
            details: [
                {
                    extraStopSurcharge: '$ 15.00',
                    midnightSurcharge: '$ 15.00',
                    waitingTime: '$15.00'
                }
            ]
        },
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    },
    {
        id: 6,
        carID: '#HT006',
        carbrandAndModel: {
            details: [
                {
                    brand: 'Mercedes Benz',
                    model: 'S400',
                }
            ]
        },
        model: 'S400',

        seatCapacity: {
            details: [
                {
                    totalSeat: 4,
                    babySeat: 'Yes'
                }
            ]
        },
        servicePrice: {
            details: [
                {
                    price: '$180.00',
                    fromLocation: 'Singapore Disposal',
                    toLocation: 'Malaysia Disposal',
                    fromDisposal: '$180.00',
                    toDisposal: '$215.00'
                }
            ]
        },
        extraPrice: {
            details: [
                {
                    extraStopSurcharge: '$ 15.00',
                    midnightSurcharge: '$ 15.00',
                    waitingTime: '$15.00'
                }
            ]
        },
        emailAddress: 'raj198672@gmail.com',
        userName: 'Johhnmay@may',
        appRoleName: 'primary',
        appRollNameColor: 'primary',
        userAccount: 25,
        status: 'Active',
        statusColor: 'success'
    }

]

export const cityList = [
    {
        options: [
            { label: "Select City", value: "Select City" },
            { label: "Aljunied", value: "Aljunied" },
            { label: "East Coast", value: "East Coast" },
            { label: "Hong Kah", value: "Hong Kah" },
            { label: "Jalan Besar", value: "Jalan Besar" },
        ]
    }
]
export const countryList = [
    {
        options: [
            { label: "Select Country", value: "Select Country" },
            { label: "Aljunied", value: "Aljunied" },
            { label: "East Coast", value: "East Coast" },
            { label: "Hong Kah", value: "Hong Kah" },
            { label: "Jalan Besar", value: "Jalan Besar" },
        ]
    }
]

export const carBrandName = [
    {
        options: [
            { label: "Select Car Brand", value: "Select Car Brand", isDisabled: true },
            { label: "Combi (13- seater)", value: "Combi (13- seater)" },
            { label: "Mercedes Benz", value: "Mercedes Benz" },
            { label: "MPV", value: "MPV" },
            { label: "Toyota Alphard Hybrid", value: "Toyota Alphard Hybrid" },
            { label: "Wheelchair Access Vehicle", value: "Wheelchair Access Vehicle" },
        ]
    }
]

export const carModelList = [
    {
        options: [
            { label: "Select Car Model Name", value: "Select Car Model Name", isDisabled: true },
            { label: "E200", value: "E200" },
            { label: "E300e", value: "E300e" },
            { label: "S320", value: "S320" },
            { label: "S400", value: "S400" },
            { label: "Toyota Noah", value: "Toyota Noah" },
            { label: "Viano", value: "Viano" },
            { label: "Voxy", value: "Voxy" },
        ]
    }
]

export const seatCapacityList = [
    {
        options: [
            { label: "Select Seat Capacity", value: "Select Seat Capacity", isDisabled: true },
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" },
            { label: "5", value: "5" },
            { label: "6", value: "6" },
            { label: "7", value: "7" },
            { label: "8", value: "8" },
            { label: "9", value: "9" },
            { label: "10", value: "10" },
            { label: "11", value: "11" },
            { label: "12", value: "12" },
            { label: "13", value: "13" },
            { label: "14", value: "14" },
            { label: "15", value: "15" },
            { label: "16", value: "16" },

           
        ]
    }
]